import { useTranslation } from "react-i18next";

export function SearchDialogLoading() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary mb-4" />
      <p className="text-sm">{t("search.searching")}...</p>
    </div>
  );
}
